import { formatDate } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';
import { NgxMatDateAdapter, NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';
import { CustomDateAdapter } from '@shared/utils/date-adapter';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-time-cell',
  templateUrl: './time-cell.component.html',
  styleUrls: ['./time-cell.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: NgxMatNativeDateAdapter, useClass: CustomDateAdapter },
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
  ],
})
export class TimeCellComponent {
  @Input() public field!: ConstrainedField;
  @ViewChild('timePicker') timePicker!: ElementRef<HTMLInputElement>;

  public onValueChange() {
    if (!this.timePicker.nativeElement.validity.valid) {
      this.field.control.setErrors({ 'badInput': true });
    }
    else {
      if (this.field.control.hasError('badInput')) {
        delete this.field.control.errors['badInput'];
      }
    }
  }

  public toDbModel(value: string | null): any {
    if (value && value.length == 5) {
      return `${value}:00`;
    }
    return value;
  }
}
